import React, { useContext, useEffect } from 'react'
import { Layout } from "../../../componentsV1/layout"
import css from './layout.module.scss'
import { toAbsoluteUrl } from '../../../utils/assetHelper'
import { NavLink } from 'react-router-dom'
import { AuthContext } from '../../../context/auth'
import { currentUserApi, getCustomerGroupApi } from '../../../api'

export const ProfileLayout = ({ children }) => {
    const { setLogOutModal, width, user, setSignUpModal, login, completeModal, setIsLoading, setSignInModal } = useContext(AuthContext)

    useEffect(() => {
        setIsLoading(true)
        currentUserApi()
            .then(res => {
                if (res.data) {
                    let data = res.data
                    getCustomerGroupApi(data?.customer?.id).then((customerGroup) => {
                        data.customer.groups = customerGroup.data?.customerGroups[0]?.groups[0]?.name
                    })
                    login(data)
                    setIsLoading(false)
                }else{
                    setIsLoading(false)
                    setSignInModal(true)
                }
            })
    }, [completeModal])


    return (
        <Layout>
            <div className={css.wrapper}>
                <div className={`container ${width < 1100 && `${css.layoutContainer}`}`} style={{ width: '100%', display: 'flex', alignItems: 'start' }}>
                    {width < 1100 && <div className={css.topbar}>
                        <div className={css.linksWrapper}>
                            <NavLink to="/v1/profile/orders" className={({ isActive }) => `${css.link} ${isActive ? css.active : ""}`}><i class="fal fa-clipboard-check"></i></NavLink>
                            <NavLink to="/v1/profile/account" className={({ isActive }) => `${css.link} ${isActive ? css.active : ""}`}><i class="fal fa-id-badge"></i></NavLink>
                            <NavLink to="/v1/profile/shipping-address" className={({ isActive }) => `${css.link} ${isActive ? css.active : ""}`}><i class="fal fa-shipping-fast"></i></NavLink>
                            <NavLink to="/v1/profile/billing-address" className={({ isActive }) => `${css.link} ${isActive ? css.active : ""}`}><i class="fal fa-address-card"></i></NavLink>
                            <NavLink to="/v1/profile/tax-exempt" className={({ isActive }) => `${css.link} ${isActive ? css.active : ""}`}><i class="fal fa-usd-circle"></i></NavLink>
                            <button className={css.signout}
                                onClick={() => {
                                    setLogOutModal(true)
                                }}
                            >
                                <i class="fal fa-sign-out" style={{ fontSize: '22px' }}></i>
                            </button>
                        </div>
                    </div>
                    }
                    {width > 1100 && <div className={css.sidebar}>
                        <div className={css.profileWrapper}>
                            {user?.customer?.avatar ?
                                <img src={user?.customer?.avatar} alt="product" className={css.profileImg} />
                                : <div className={css.customerProfile}>{user?.customer?.first_name[0]?.toUpperCase()}</div>}
                            <div className={css.profileDetails}>
                                <h5>{user?.customer?.first_name} {user?.customer?.last_name}</h5>
                                <h6>{user?.customer?.email}</h6>
                                <p>ID: {user?.customer?.id.slice(25, 30)}</p>
                            </div>
                            <hr />
                        </div>
                        <div className={css.linksWrapper}>
                            <NavLink to="/v1/profile/orders"  className={({ isActive }) => `${css.link} ${isActive ? css.active : ""}`}><i class="fal fa-clipboard-check"></i>Order History</NavLink>
                            <NavLink to="/v1/profile/account" className={({ isActive }) => `${css.link} ${isActive ? css.active : ""}`}><i class="fal fa-id-badge"></i>Profile Information</NavLink>
                            <NavLink to="/v1/profile/shipping-address" className={({ isActive }) => `${css.link} ${isActive ? css.active : ""}`}><i class="fal fa-shipping-fast"></i>Shipping Address</NavLink>
                            <NavLink to="/v1/profile/billing-address" className={({ isActive }) => `${css.link} ${isActive ? css.active : ""}`}><i class="fal fa-address-card"></i>Billing Address</NavLink>
                            <NavLink to="/v1/profile/tax-exempt" className={({ isActive }) => `${css.link} ${isActive ? css.active : ""}`}><i class="fal fa-usd-circle"></i>Tax Exempt</NavLink>
                        </div>
                        <button className={css.signout}
                            onClick={() => {
                                setLogOutModal(true)
                            }}
                        >
                            <i class="fal fa-sign-out"></i>Sign Out
                        </button>
                    </div>
                    }
                    <main style={{ height: '100%', width: '100%', overflowY: 'hidden' }}>
                        {(!user?.customer?.shipping_addresses?.length || !user?.customer?.billing_address || user?.customer?.is_tax_exempt === null || !user?.customer?.metadata?.is_email_verified) &&
                            <div className={css.finishRegistration}>
                                <div className={css.row}>
                                    <div className={css.icon}>
                                        <i className='fal fa-info-circle' style={{ fontSize: '20px' }}></i>
                                    </div>
                                    <p>Finish your account registration to be able to make orders.</p>
                                </div>
                                <button className={`btn ${css.ctaBtn}`}
                                    onClick={() => {
                                        setSignUpModal(true)
                                    }}
                                >Finish Registration</button>
                            </div>
                        }
                        {children}
                    </main>
                </div>
            </div>
        </Layout>
    )
}